import { render, staticRenderFns } from "./Terms-Use.vue?vue&type=template&id=580bbd5e&scoped=true&"
import script from "./Terms-Use.vue?vue&type=script&lang=js&"
export * from "./Terms-Use.vue?vue&type=script&lang=js&"
import style0 from "./Terms-Use.vue?vue&type=style&index=0&id=580bbd5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580bbd5e",
  null
  
)

export default component.exports